module.exports = __webpack_public_path__ + "img/1f9a7.8936ee4.svg";